import { useTranslation } from 'react-i18next';
import {
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
} from '@/Domain/components/Shared/Form/Form';
import { FormMessage } from '@/Domain/components/Shared/FormCustom/FormCustom';
import { AutosizeTextarea } from '@/Domain/components/Shared/Textarea/Textarea';

export const DescriptionField = () => {
  const { t } = useTranslation('actions_page', { keyPrefix: 'sheet' });

  return (
    <FormField
      name="description"
      render={({ field }) => (
        <FormItem>
          <FormLabel>{t('form.description_ai.label')}</FormLabel>
          <FormDescription>{t('form.description_ai.description')}</FormDescription>
          <FormControl>
            <AutosizeTextarea
              data-testid="http-request-action-form-description-input"
              placeholder={t('form.description_ai.placeholder')}
              minHeight={100}
              className="px-4 mb-1"
              {...field}
            />
          </FormControl>
          <p
            data-testid="http-request-action-form-description-helper"
            className="text-xs text-muted-foreground mt-1"
          >
            {t('form.description_ai.helper_text')}
          </p>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};
